import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import BaseModal from "../base/BaseModal";

export default function DeleteDocumentModal({
  isOpen,
  onClose,
  onConfirm,
  document,
  isOwnDoc = true,
  loading = false,
}) {
  const [lyDoXoa, setLyDoXoa] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setLyDoXoa("");
      setError("");
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!isOwnDoc && !lyDoXoa.trim()) {
      setError("Vui lòng nhập lý do xóa tài liệu");
      return;
    }
    if (onConfirm) {
      onConfirm(lyDoXoa.trim());
    }
  };

  if (!isOpen) return null;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={loading ? undefined : onClose}
      title="Xóa tài liệu"
      size="md"
      showCloseButton={!loading}
      footer={
        <div className="flex items-center justify-end gap-2.5 w-full">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="px-4 py-1.5 text-xs sm:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 cursor-pointer"
          >
            Hủy
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading || (!isOwnDoc && !lyDoXoa.trim())}
            className="px-4 py-1.5 text-xs sm:text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5 cursor-pointer"
          >
            {loading && (
              <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            )}
            <span>{loading ? "Đang xóa..." : "Xác nhận xóa"}</span>
          </button>
        </div>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-3">
        {/* Document Summary Info */}
        {document && (
          <div className="bg-gray-50 rounded-lg px-3 py-2 border border-gray-200">
            {document.so_hieu && (
              <div className="text-xs font-semibold text-blue-700 mb-0.5">
                Số hiệu: {document.so_hieu}
              </div>
            )}
            <div className="text-xs font-medium text-gray-900 line-clamp-2" title={document.tieu_de}>
              {document.tieu_de || "---"}
            </div>
          </div>
        )}

        {/* Info Notice */}
        <div className="px-3 py-2 bg-red-50 border border-red-200 rounded-lg text-xs text-red-800 leading-relaxed">
          Tài liệu sẽ được chuyển vào mục <strong>Tài liệu đã xóa</strong> và lưu giữ tạm thời trong 30 ngày.
        </div>

        {/* Deletion Reason Input (Required for non-own docs) */}
        {!isOwnDoc && (
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="text-xs font-medium text-gray-700">
                Lý do xóa tài liệu <span className="text-red-500 font-medium">*</span>
              </label>
              <span className={`text-[11px] ${lyDoXoa.length > 450 ? "text-amber-600 font-medium" : "text-gray-400"}`}>
                {lyDoXoa.length}/500
              </span>
            </div>
            <textarea
              rows={3}
              maxLength={500}
              value={lyDoXoa}
              onChange={(e) => {
                setLyDoXoa(e.target.value);
                if (error && e.target.value.trim()) {
                  setError("");
                }
              }}
              disabled={loading}
              placeholder="Nhập lý do xóa tài liệu do người khác tạo (bắt buộc)..."
              className={`w-full px-3 py-2 text-xs sm:text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-colors placeholder:text-gray-400 resize-none disabled:bg-gray-50 disabled:text-gray-500 ${
                error ? "border-red-500 bg-red-50/20" : "border-gray-300"
              }`}
            />
            {error && (
              <p className="mt-1 text-xs text-red-600 font-medium">{error}</p>
            )}
          </div>
        )}
      </form>
    </BaseModal>
  );
}

DeleteDocumentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  document: PropTypes.object,
  isOwnDoc: PropTypes.bool,
  loading: PropTypes.bool,
};
